import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Spin, Tabs } from 'antd';
import Table from '../../../../TableResizable';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';

const Tab4 = (props: { form?: any; data: any[]; dataProv?: any[] }) => {
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});

  useEffect(() => {
    forceUpdate({});
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: 'N° Échéance',
      dataIndex: 'NumeroEch',
      key: 'NumeroEch',
      width: 120,
      align: 'center',
      render: (text: any) => (
        <span style={{ fontWeight: 500, color: '#1890ff' }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Date Échéance',
      dataIndex: 'DateEcheance',
      key: 'DateEcheance',
      width: 150,
      align: 'center',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Capital Initial',
      dataIndex: 'CapitalInitial',
      key: 'CapitalInitial',
      width: 160,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Part Recup. Bien',
      dataIndex: 'PartRecuperationBien',
      key: 'PartRecuperationBien',
      width: 160,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Charge',
      dataIndex: 'PartCharge',
      key: 'PartCharge',
      width: 100,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Marge Locative',
      dataIndex: 'MargeLocative',
      key: 'MargeLocative',
      width: 160,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'TVA',
      dataIndex: 'TVA',
      key: 'TVA',
      width: 120,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Loyer TTC',
      dataIndex: 'LoyerTTC',
      key: 'LoyerTTC',
      width: 180,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Solde Restant TTC',
      dataIndex: 'SoldeRestantTTC',
      key: 'SoldeRestantTTC',
      width: 180,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Valeur Bien Restante',
      dataIndex: 'ValeurBienRestante',
      key: 'ValeurBienRestante',
      width: 180,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
  ];

  const columnsProv: ColumnsType<any> = [
    { 
      title: 'N° Échéance', 
      dataIndex: 'NumeroRang', 
      key: 'NumeroEch', 
      width: 100, 
      align: 'center' 
    },
    { 
      title: 'Date', 
      dataIndex: 'DateDotation', 
      key: 'DateEcheance', 
      width: 120, 
      align: 'center', 
      render: (text: any) => <span>{text ? new Date(text).toLocaleDateString('fr-FR') : ''}</span> 
    },
    { 
      title: 'Dotation Amort. (68)', 
      dataIndex: 'DotationPeriode', 
      key: 'Dotation', 
      width: 150, 
      align: 'right', 
      render: (text: any) => <span>{Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })}</span> 
    },
    { 
      title: 'Amort. Cumulés (28)', 
      dataIndex: 'CumulAmortissement', 
      key: 'AmortissementCumule', 
      width: 150, 
      align: 'right', 
      render: (text: any) => <span>{Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })}</span> 
    }
  ];

  return (
    <div className='tabItem'>
      <Box fontStyle='inherit' className='border' height={'60%'} width={'85%'} position={'absolute'}>
        <div className='clientP'>
          <div>
            {/* Tableaux */}
            <Box position={'relative'} display={'flex'} fontStyle='inherit' width={'99%'} className='border-left tabElement'>
              <Spin spinning={loading}>
                <Tabs 
                  size="small" 
                  type="card" 
                  items={[
                    {
                      key: '1',
                      label: 'Tableau Locatif (Client)',
                      children: (
                        <Table 
                          size='small' 
                          style={{ width: '85%' }} 
                          columns={columns} 
                          dataSource={props.data} 
                          scroll={{ y: 220, x: 10 }} 
                          pagination={false} 
                        />
                      )
                    },
                    {
                      key: '2',
                      label: 'Tableau de dotation (Nantissement)',
                      children: (
                        <Table 
                          size='small' 
                          style={{ width: 'auto' }} 
                          columns={columnsProv} 
                          dataSource={props.dataProv || []} 
                          scroll={{ y: 220, x: 10 }} 
                          pagination={false} 
                        />
                      )
                    }
                  ]} 
                />
              </Spin>
            </Box>

            {/* Input Montant demandé en dessous des tableaux */}
            <Box display={'flex'} width={'100%'} mt={10} fontStyle='inherit' className='border-left bordure1 tabElement2'>
              <InputForm 
                money 
                notRequired 
                disabled 
                width={8} 
                label='Montant demandé' 
                name='MontantDemande' 
                type='number' 
                error='mobile' 
              />
            </Box>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default Tab4;